<template>
  <div class="background"
       :style="backgroundStyle"
  ></div>
</template>

<script>
export default {
  name: 'LayoutBackground',
  props: {
    image: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundStyle() {
      return `backgroundImage: url(${this.image})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/login/layouts/LayoutBackground.vue